import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { Button, Form, FormGroup, Label, Col } from "reactstrap";
import { Get, Post, Nama_DESA } from "../../../function/Koneksi";
import {
  generateAlamat,
  CapitalizeWord,
  DataToken
} from "../../../function/Format";
// import { getList } from '../../../function/get-data';
import Select from "react-select";
import NumberFormat from "react-number-format";
import Datetime from "react-datetime";
import Dropzone from "react-dropzone";
import Resizer from "react-image-file-resizer";
import Switch from "react-switch";

const ModalSuratGaib = ({
  data,
  fieldInputan,
  statusData,
  optionData,
  setAlert,
  isOpen,
  setIsOpen,
  statusRefresh,
  setStatusRefresh,
  propsData,
  kiosk
}) => {
  const dateFormat = require("dateformat");

  const initFormData = {
    formSelect: optionData.formSelect,
    formSelectPenduduk: optionData.formSelectPenduduk,
    frmListPerangkat: optionData.frmListPerangkat,
    manualStatus: optionData.manualStatus,
    detailStatus: optionData.detailStatus,
    dinamisTemplate: optionData.dinamisTemplate,
    pemohonStatus: optionData.pemohonStatus,
    detail: [],
    status: {
      form: false,
      btnForm: false,
      btnAksi: [],
      dataPenduduk: "none",
      dataPasangan: "none",
      frmPreviewDraft: false,
      frmDetailPengajuan: false,
      jenis_form: "",
      jenis_input: ""
    },
    show: false,
    basicTitle: "",
    basicType: "default",
    pesanAlert: "",
    formPasangan: "none",

    // Preview surat
    get_data_surat: [],
    get_jenis_surat: "",

    // Tanda Tangan
    accButtonPerangkatDesa: optionData.accButtonPerangkatDesa,
    listPerangkatDesa: optionData.listPerangkatDesa,
    ttdSelected: optionData.ttdSelected
  };

  const initChecked = {
    pemohonStatus: optionData.pemohonStatus
  };

  const [seed, setSeed] = useState(1);
  const [formData, setFormData] = useState(initFormData);
  const [props, setProps] = useState(propsData);
  const [kioskMode, setKioskMode] = useState(kiosk);
  const [loads, setLoads] = useState(false);
  const [dt, setDt] = useState(data ? data : []);
  const [draggable, setDraggable] = useState({
    isDown: false,
    startY: null,
    scrollUp: null
  });
  const [checked, setChecked] = useState(initChecked);

  useEffect(() => {
    if (document.getElementById("modalForm")) {
      document.getElementById("modalForm").reset();
    }

    // console.log('data useeffect')
    // console.log(props)
    // console.log(data)
    // console.log(optionData)
    // console.log(fieldInputan)
    // console.log(fieldInputan.dasar_surat)

    // console.log('surat internal kondisi simpan')
    // console.log(dt)
    // console.log(dt.dasar_surat)
    // console.log(dt.dasar_surat[0])
    // console.log('belum masuk???')
    if (
      optionData.dataSurat &&
      optionData.dataSurat.jenis_layanan === "Internal" &&
      fieldInputan.dasar_surat === undefined
    ) {
      dt["dasar_surat"] = [
        {
          key: "dikeluarkan_oleh",
          value: {
            value: "Desa",
            label: "Desa"
          },
          pemohon: false
        }
      ];
    }

    // console.log('setelah masuk???')

    setDt(data ? data : []);
    setFormData(
      data
        ? {
            ...initFormData,
            status: optionData.status
          }
        : initFormData
    );
    setChecked(
      data
        ? {
            ...initChecked,
            pemohonStatus: optionData.pemohonStatus
          }
        : initChecked
    );
  }, [isOpen]);

  const getPenduduk = (e, child, parent, level, index, index2) => {
    if (e) {
      if (kioskMode) {
        props.setLoadingPreview(true);
      } else {
        setAlert({
          loadingPreview: true
        });
      }

      Get("penduduk/find", e.value, data => {
        const alamat = generateAlamat(data.results);
        let alamat_kk = "";

        if (data.results.data_kk) {
          alamat_kk = data.results.data_kk.alamat;
        }

        if (level === "level1") {
          let newData = dt[parent];

          fieldInputan[parent].map((data_array2, key2) => {
            let newValue = "";
            if (data_array2.key === "nik") {
              newValue = e;
            } else if (data_array2.key === "no_kk") {
              newValue = data.results.id_kk;
            } else if (data_array2.key === "tanggal_lahir") {
              newValue = dateFormat(
                new Date(data.results.tanggal_lahir),
                "yyyy-mm-dd"
              );
            } else if (data_array2.key === "pekerjaan") {
              if (data_array2.type === "select") {
                newValue = {
                  value: data.results.data_pekerjaan.uuid,
                  label: data.results.data_pekerjaan.nama
                };
              } else {
                newValue = data.results.data_pekerjaan.nama;
              }
            } else if (data_array2.key === "shdk") {
              if (data_array2.type === "select") {
                newValue = {
                  value: data.results.data_shdk.uuid,
                  label: data.results.data_shdk.nama
                };
              } else {
                newValue = data.results.data_pekerjaan.nama;
              }
            } else if (data_array2.key === "pendidikan_terakhir") {
              if (data_array2.type === "select") {
                newValue = {
                  value: data.results.data_pendidikan_terakhir.uuid,
                  label: data.results.data_pendidikan_terakhir.nama
                };
              } else {
                newValue = data.results.data_pendidikan_terakhir.nama;
              }
            } else if (data_array2.key === "agama") {
              if (data_array2.type === "select") {
                newValue = {
                  value: data.results.data_agama.uuid,
                  label: data.results.data_agama.nama
                };
              } else {
                newValue = data.results.data_agama.nama;
              }
            } else if (data_array2.key === "jenis_kelamin") {
              newValue = { value: data.results.jk, label: data.results.jk };
            } else if (data_array2.key === "status_perkawinan") {
              newValue = {
                value: data.results.status_perkawinan,
                label: data.results.status_perkawinan
              };
            } else if (data_array2.key === "alamat") {
              newValue = alamat;
            } else if (data_array2.key === "alamat_kk") {
              newValue = alamat_kk;
            } else if (data_array2.key === "kewarganegaraan") {
              newValue = {
                value:
                  data.results.data_penduduk_detail &&
                  data.results.data_penduduk_detail.kewarganegaraan
                    ? data.results.data_penduduk_detail.kewarganegaraan
                    : "WNI",
                label:
                  data.results.data_penduduk_detail &&
                  data.results.data_penduduk_detail.kewarganegaraan
                    ? data.results.data_penduduk_detail.kewarganegaraan
                    : "WNI"
              };
            } else {
              newValue = data.results[data_array2.key];
            }

            if (dt[parent].length < fieldInputan[parent].length) {
              newData.push({
                key: data_array2.key,
                value: newValue
              });
            } else {
              newData[key2] = {
                key: data_array2.key,
                value: newValue
              };
            }
          });

          setFormData({
            ...formData,
            detailStatus: {
              ...formData.detailStatus,
              [parent]: true
            }
          });
        } else if (level === "level2") {
          let newData = dt[parent];

          fieldInputan[parent][0].map((data_array, key) => {
            data_array.map((data_array2, key2) => {
              let newValue = "";
              if (data_array2.key === "nik") {
                newValue = e;
              } else if (data_array2.key === "no_kk") {
                newValue = data.results.id_kk;
              } else if (data_array2.key === "tanggal_lahir") {
                newValue = dateFormat(
                  new Date(data.results.tanggal_lahir),
                  "yyyy-mm-dd"
                );
              } else if (data_array2.key === "pekerjaan") {
                if (data_array2.type === "select") {
                  newValue = {
                    value: data.results.data_pekerjaan.uuid,
                    label: data.results.data_pekerjaan.nama
                  };
                } else {
                  newValue = data.results.data_pekerjaan.nama;
                }
              } else if (data_array2.key === "shdk") {
                if (data_array2.type === "select") {
                  newValue = {
                    value: data.results.data_shdk.uuid,
                    label: data.results.data_shdk.nama
                  };
                } else {
                  newValue = data.results.data_pekerjaan.nama;
                }
              } else if (data_array2.key === "pendidikan_terakhir") {
                if (data_array2.type === "select") {
                  newValue = {
                    value: data.results.data_pendidikan_terakhir.uuid,
                    label: data.results.data_pendidikan_terakhir.nama
                  };
                } else {
                  newValue = data.results.data_pendidikan_terakhir.nama;
                }
              } else if (data_array2.key === "agama") {
                if (data_array2.type === "select") {
                  newValue = {
                    value: data.results.data_agama.uuid,
                    label: data.results.data_agama.nama
                  };
                } else {
                  newValue = data.results.data_agama.nama;
                }
              } else if (data_array2.key === "jenis_kelamin") {
                newValue = { value: data.results.jk, label: data.results.jk };
              } else if (data_array2.key === "status_perkawinan") {
                newValue = {
                  value: data.results.status_perkawinan,
                  label: data.results.status_perkawinan
                };
              } else if (data_array2.key === "alamat") {
                newValue = alamat;
              } else if (data_array2.key === "alamat_kk") {
                newValue = alamat_kk;
              } else if (data_array2.key === "kewarganegaraan") {
                newValue = {
                  value:
                    data.results.data_penduduk_detail &&
                    data.results.data_penduduk_detail.kewarganegaraan
                      ? data.results.data_penduduk_detail.kewarganegaraan
                      : "WNI",
                  label:
                    data.results.data_penduduk_detail &&
                    data.results.data_penduduk_detail.kewarganegaraan
                      ? data.results.data_penduduk_detail.kewarganegaraan
                      : "WNI"
                };
              } else {
                newValue = data.results[data_array2.key];
              }

              newData[index][key2] = {
                key: data_array2.key,
                value: newValue
              };
            });
          });

          setFormData({
            ...formData,
            detailStatus: {
              ...formData.detailStatus,
              [parent]: {
                ...formData.detailStatus[parent],
                [index]: true
              }
            }
          });
        }

        if (kioskMode) {
          props.setLoadingPreview(false);
        } else {
          setAlert({
            loadingPreview: false
          });
        }
      });
    } else {
      if (level === "level1") {
        setFormData({
          ...formData,
          detailStatus: {
            ...formData.detailStatus,
            [parent]: false
          },
          formSelectPenduduk: {
            ...formData.formSelectPenduduk,
            [parent]: {
              ...formData.formSelectPenduduk[parent],
              [child]: formData.dinamisTemplate.nik
            }
          }
        });
        setDt({
          ...dt,
          [parent]: []
        });
      } else if (level === "level2") {
        setFormData({
          ...formData,
          formSelectPenduduk: {
            ...formData.formSelectPenduduk,
            [parent]: {
              ...formData.formSelectPenduduk[parent],
              [child]: formData.dinamisTemplate.nik
            }
          }
        });

        let newData = dt[parent];
        newData[index] = [];
      }
    }
  };

  const getPerangkat = (e, child, parent, level, index, index2) => {
    if (e) {
      if (kioskMode) {
        props.setLoadingPreview(true);
      } else {
        setAlert({
          loadingPreview: true
        });
      }

      Get("perangkat/find", e.value, data => {
        if (level === "level1") {
          let newData = dt[parent];

          fieldInputan[parent].map((data_array2, key2) => {
            let newValue = "";
            if (data_array2.key === "perangkat") {
              newValue = e;
            } else if (data_array2.key === "nama") {
              newValue = data.results.data_penduduk.nama;
            } else if (data_array2.key === "nip") {
              newValue = data.results.nip;
            } else if (data_array2.key === "jabatan") {
              if (data_array2.type === "select") {
                newValue = {
                  value: data.results.data_jabatan.uuid,
                  label: data.results.data_jabatan.nama
                };
              } else {
                newValue = data.results.data_jabatan.nama;
              }
            } else if (data_array2.key === "tanggal_mulai") {
              newValue = dateFormat(
                new Date(data.results.tanggal_mulai),
                "yyyy-mm-dd"
              );
            } else if (data_array2.key === "tanggal_selesai") {
              newValue = dateFormat(
                new Date(data.results.tanggal_selesai),
                "yyyy-mm-dd"
              );
            } else if (data_array2.key === "status_pegawai") {
              if (data_array2.type === "select") {
                newValue = {
                  value: data.results.status_pegawai,
                  label: data.results.status_pegawai
                };
              } else {
                newValue = data.results.status_pegawai;
              }
            } else {
              newValue = data.results[data_array2.key];
            }

            if (dt[parent].length < fieldInputan[parent].length) {
              newData.push({
                key: data_array2.key,
                value: newValue
              });
            } else {
              newData[key2] = {
                key: data_array2.key,
                value: newValue
              };
            }
          });

          setFormData({
            ...formData,
            detailStatus: {
              ...formData.detailStatus,
              [parent]: true
            }
          });
        } else if (level === "level2") {
          let newData = dt[parent];

          fieldInputan[parent][0].map((data_array, key) => {
            data_array.map((data_array2, key2) => {
              let newValue = "";
              if (data_array2.key === "perangkat") {
                newValue = e;
              } else if (data_array2.key === "nama") {
                newValue = data.results.data_penduduk.nama;
              } else if (data_array2.key === "nip") {
                newValue = data.results.nip;
              } else if (data_array2.key === "jabatan") {
                if (data_array2.type === "select") {
                  newValue = {
                    value: data.results.data_jabatan.uuid,
                    label: data.results.data_jabatan.nama
                  };
                } else {
                  newValue = data.results.data_jabatan.nama;
                }
              } else if (data_array2.key === "tanggal_mulai") {
                newValue = dateFormat(
                  new Date(data.results.tanggal_mulai),
                  "yyyy-mm-dd"
                );
              } else if (data_array2.key === "tanggal_selesai") {
                newValue = dateFormat(
                  new Date(data.results.tanggal_selesai),
                  "yyyy-mm-dd"
                );
              } else if (data_array2.key === "status_pegawai") {
                if (data_array2.type === "select") {
                  newValue = {
                    value: data.results.status_pegawai,
                    label: data.results.status_pegawai
                  };
                } else {
                  newValue = data.results.status_pegawai;
                }
              } else {
                newValue = data.results[data_array2.key];
              }

              newData[index][key2] = {
                key: data_array2.key,
                value: newValue
              };
            });
          });

          setFormData({
            ...formData,
            detailStatus: {
              ...formData.detailStatus,
              [parent]: {
                ...formData.detailStatus[parent],
                [index]: true
              }
            }
          });
        }

        if (kioskMode) {
          props.setLoadingPreview(false);
        } else {
          setAlert({
            loadingPreview: false
          });
        }
      });
    } else {
      if (level === "level1") {
        setFormData({
          ...formData,
          detailStatus: {
            ...formData.detailStatus,
            [parent]: false
          },
          formSelectPenduduk: {
            ...formData.formSelectPenduduk,
            [parent]: {
              ...formData.formSelectPenduduk[parent],
              [child]: formData.dinamisTemplate.nik
            }
          }
        });
        setDt({
          ...dt,
          [parent]: []
        });
      } else if (level === "level2") {
        setFormData({
          ...formData,
          formSelectPenduduk: {
            ...formData.formSelectPenduduk,
            [parent]: {
              ...formData.formSelectPenduduk[parent],
              [child]: formData.dinamisTemplate.nik
            }
          }
        });

        let newData = dt[parent];
        newData[index] = [];
      }
    }
  };

  const handleChangeSelect = (e, child, parent, level, index, index2) => {
    if (e) {
      if (level === "level1") {
        setDt({
          ...dt,
          [parent]: {
            ...dt[parent],
            [index]: {
              ...dt[parent][index],
              key: child,
              value: e
            }
          }
        });
      } else if (level === "level2") {
        setDt({
          ...dt,
          [parent]: {
            ...dt[parent],
            [index]: {
              ...dt[parent][index],
              [index2]: {
                ...dt[parent][index][index2],
                key: child,
                value: e
              }
            }
          }
        });
      }
    } else {
      if (level === "level1") {
        setDt({
          ...dt,
          [parent]: {
            ...dt[parent],
            [index]: {
              ...dt[parent][index],
              key: child,
              value: ""
            }
          }
        });
      } else if (level === "level2") {
        setDt({
          ...dt,
          [parent]: {
            ...dt[parent],
            [index]: {
              ...dt[parent][index],
              [index2]: {
                ...dt[parent][index][index2],
                key: child,
                value: ""
              }
            }
          }
        });
      }
    }
  };

  const handleChangeInputText = (e, child, parent, level, index, index2) => {
    if (level === "level1") {
      if (parent === "data_penandatangan") {
        setDt({
          ...dt,
          [parent]: {
            ...dt[parent],
            [index]: {
              ...dt[parent][index],
              key: child,
              value: e.target.value
            }
          }
        });

        if (Array.isArray(dt[parent]) === false) {
          dt[parent] = Object.values(dt[parent]);
        }
      } else {
        if (child === "nik") {
          setDt({
            ...dt,
            [parent]: {
              ...dt[parent],
              [index]: {
                ...dt[parent][index],
                key: child,
                value: {
                  value: e.target.value,
                  label: e.target.value
                }
              }
            }
          });
        } else {
          setDt({
            ...dt,
            [parent]: {
              ...dt[parent],
              [index]: {
                ...dt[parent][index],
                key: child,
                value: e.target.value
              }
            }
          });
        }

        if (Array.isArray(dt[parent]) === false) {
          dt[parent] = Object.values(dt[parent]);
        }
        dt[parent].map((data, key) => {
          if (Array.isArray(dt[parent][key]) === false) {
            dt[parent][key] = Object.values(dt[parent][key]);
          }
        });
      }
    } else if (level === "level2") {
      if (Array.isArray(dt[parent])) {
        if (child === "nik") {
          setDt({
            ...dt,
            [parent]: {
              ...dt[parent],
              [index]: {
                ...dt[parent][index],
                [index2]: {
                  ...dt[parent][index][index2],
                  key: child,
                  value: {
                    value: e.target.value,
                    label: e.target.value
                  }
                }
              }
            }
          });
        } else {
          setDt({
            ...dt,
            [parent]: {
              ...dt[parent],
              [index]: {
                ...dt[parent][index],
                [index2]: {
                  ...dt[parent][index][index2],
                  key: child,
                  value: e.target.value
                }
              }
            }
          });
        }
      } else {
        if (child === "nik") {
          setDt({
            ...dt,
            [parent]: {
              ...dt[parent],
              [index]: {
                ...dt[parent][index],
                [index2]: {
                  ...dt[parent][index][index2],
                  key: child,
                  value: {
                    value: e.target.value,
                    label: e.target.value
                  }
                }
              }
            }
          });
        } else {
          setDt({
            ...dt,
            [parent]: {
              ...dt[parent],
              [index]: {
                ...dt[parent][index],
                [index2]: {
                  ...dt[parent][index][index2],
                  key: child,
                  value: e.target.value
                }
              }
            }
          });
        }

        dt[parent] = Object.values(dt[parent]);
        dt[parent].map((data, key) => {
          if (Array.isArray(dt[parent][key]) === false) {
            dt[parent][key] = Object.values(dt[parent][key]);
          }
        });
      }
    }
  };

  const handleChangeInputNIK = (e, child, parent, nama_model, level, index) => {
    if (e && kioskMode == false) {
      Get("get-model/penduduk?q=" + e, null, data => {
        let optionValue = [];
        data.forEach(dt => {
          optionValue.push({
            value: dt.id,
            label: dt.id + " (" + dt.nama + ")"
          });
        });

        if (level === "level1") {
          setFormData({
            ...formData,
            formSelectPenduduk: {
              ...formData.formSelectPenduduk,
              [parent]: {
                ...formData.formSelectPenduduk[parent],
                [child]: optionValue
              }
            }
          });
        } else if (level === "level2") {
          setFormData({
            ...formData,
            formSelectPenduduk: {
              ...formData.formSelectPenduduk,
              [parent]: {
                ...formData.formSelectPenduduk[parent],
                [index]: {
                  ...formData.formSelectPenduduk[parent][index],
                  [child]: optionValue
                }
              }
            }
          });
        }
      });
    }
  };

  const processGbr = (d, jenis, type_file, parent, level, index, index2) => {
    if (d.length === 1) {
      let type = d[0].type.split("/");
      if (type_file === "image") {
        if (
          type[1] === "jpg" ||
          type[1] === "jpeg" ||
          type[1] === "png" ||
          type[1] === "bmp" ||
          type[1] === "tiff" ||
          type[1] === "webp"
        ) {
          setLoads(true);
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              btnForm: true
            }
          });

          let bodyFormData = new FormData();
          bodyFormData.append("files", d[0]);

          Post("upload-file/" + jenis, null, bodyFormData, data => {
            Resizer.imageFileResizer(
              d[0],
              300,
              300,
              type[1],
              100,
              0,
              uri => {
                if (level === "level1") {
                  setDt({
                    ...dt,
                    [parent]: {
                      ...dt[parent],
                      [index]: {
                        ...dt[parent][index],
                        key: jenis,
                        value: data.data.results
                      }
                    }
                  });
                } else if (level === "level2") {
                  setDt({
                    ...dt,
                    [parent]: {
                      ...dt[parent],
                      [index]: {
                        ...dt[parent][index],
                        [index2]: {
                          ...dt[parent][index][index2],
                          key: jenis,
                          value: data.data.results
                        }
                      }
                    }
                  });
                }

                setLoads(false);

                setFormData({
                  ...formData,
                  status: {
                    ...formData.status,
                    btnForm: false
                  }
                });
              },
              "base64"
            );
          });
        } else {
          if (level === "level1") {
            setDt({
              ...dt,
              [parent]: {
                ...dt[parent],
                [index]: {
                  ...dt[parent][index],
                  key: jenis,
                  value: ""
                }
              }
            });
          } else if (level === "level2") {
            setDt({
              ...dt,
              [parent]: {
                ...dt[parent],
                [index]: {
                  ...dt[parent][index],
                  [index2]: {
                    ...dt[parent][index][index2],
                    key: jenis,
                    value: ""
                  }
                }
              }
            });
          }
          const alertData = {
            show: true,
            basicType: "warning",
            basicTitle: "Upload File " + jenis,
            pesanAlert: "Type file tidak valid"
          };
          setAlert(alertData);
        }
      } else if (type_file === "file") {
        if (
          type[1] === "pdf" ||
          type[1] === "doc" ||
          type[1] === "docx" ||
          type[1] === "xls" ||
          type[1] === "xlsx"
        ) {
          setLoads(true);
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              btnForm: true
            }
          });

          let bodyFormData = new FormData();
          bodyFormData.append("files", d[0]);

          Post("upload-file/" + jenis, null, bodyFormData, data => {
            if (level === "level1") {
              setDt({
                ...dt,
                [parent]: {
                  ...dt[parent],
                  [index]: {
                    ...dt[parent][index],
                    key: jenis,
                    value: data.data.results
                  }
                }
              });
            } else if (level === "level2") {
              setDt({
                ...dt,
                [parent]: {
                  ...dt[parent],
                  [index]: {
                    ...dt[parent][index],
                    [index2]: {
                      ...dt[parent][index][index2],
                      key: jenis,
                      value: data.data.results
                    }
                  }
                }
              });
            }

            setLoads(false);

            setFormData({
              ...formData,
              status: {
                ...formData.status,
                btnForm: false
              }
            });
          });
        } else {
          if (level === "level1") {
            setDt({
              ...dt,
              [parent]: {
                ...dt[parent],
                [index]: {
                  ...dt[parent][index],
                  key: jenis,
                  value: ""
                }
              }
            });
          } else if (level === "level2") {
            setDt({
              ...dt,
              [parent]: {
                ...dt[parent],
                [index]: {
                  ...dt[parent][index],
                  [index2]: {
                    ...dt[parent][index][index2],
                    key: jenis,
                    value: ""
                  }
                }
              }
            });
          }
          const alertData = {
            show: true,
            basicType: "warning",
            basicTitle: "Upload File " + jenis,
            pesanAlert: "Type file tidak valid"
          };
          setAlert(alertData);
        }
      }
    } else {
      if (level === "level1") {
        setDt({
          ...dt,
          [parent]: {
            ...dt[parent],
            [index]: {
              ...dt[parent][index],
              key: jenis,
              value: ""
            }
          }
        });
      } else if (level === "level2") {
        setDt({
          ...dt,
          [parent]: {
            ...dt[parent],
            [index]: {
              ...dt[parent][index],
              [index2]: {
                ...dt[parent][index][index2],
                key: jenis,
                value: ""
              }
            }
          }
        });
      }
      const alertData = {
        show: true,
        basicType: "warning",
        basicTitle: "Upload File " + jenis,
        pesanAlert: "Type file tidak valid"
      };
      setAlert(alertData);
    }
  };

  const tambahComponent = parent => {
    let newFieldInputan = fieldInputan[parent];

    let newIndex = fieldInputan[parent].length;

    if (Array.isArray(dt[parent]) === false) {
      dt[parent] = Object.values(dt[parent]);
      dt[parent].map((data, key) => {
        if (Array.isArray(dt[parent][key]) === false) {
          dt[parent][key] = Object.values(dt[parent][key]);
        }
      });
    }

    fieldInputan[parent][0].map((data_level1, key_level1) => {
      if (data_level1[0].type === "nik") {
        data_level1.map((data_field, key_field) => {
          if (data_field.type === "nik") {
            setFormData({
              ...formData,
              formSelectPenduduk: {
                ...formData.formSelectPenduduk,
                [parent]: {
                  ...formData.formSelectPenduduk[parent],
                  [newIndex]: {
                    nik: formData.dinamisTemplate.nik
                  }
                }
              },
              detailStatus: {
                ...formData.detailStatus,
                [parent]: {
                  ...formData.detailStatus[parent],
                  [newIndex]: false
                }
              },
              manualStatus: {
                ...formData.manualStatus,
                [parent]: {
                  ...formData.manualStatus[parent],
                  [newIndex]: null
                }
              }
            });
          }
        });
      } else if (data_level1[0].type === "perangkat") {
        data_level1.map((data_field, key_field) => {
          if (data_field.type === "perangkat") {
            setFormData({
              ...formData,
              formSelect: {
                ...formData.formSelect,
                [parent]: {
                  ...formData.formSelect[parent],
                  [newIndex]: {
                    perangkat: formData.dinamisTemplate.perangkat
                  }
                }
              },
              detailStatus: {
                ...formData.detailStatus,
                [parent]: {
                  ...formData.detailStatus[parent],
                  [newIndex]: false
                }
              },
              manualStatus: {
                ...formData.manualStatus,
                [parent]: {
                  ...formData.manualStatus[parent],
                  [newIndex]: true
                }
              }
            });
          }
        });
      } else {
        setFormData({
          ...formData,
          detailStatus: {
            ...formData.detailStatus,
            [parent]: {
              ...formData.detailStatus[parent],
              [newIndex]: true
            }
          },
          manualStatus: {
            ...formData.manualStatus,
            [parent]: {
              ...formData.manualStatus[parent],
              [newIndex]: true
            }
          }
        });
      }
    });

    newFieldInputan.push(formData.dinamisTemplate[parent]);

    setDt({
      ...dt,
      [parent]: {
        ...dt[parent],
        [newIndex]: []
      }
    });
    // console.log('tambah com after')
    // console.log(dt)
    // console.log(formData)
    setSeed(Math.random());
  };

  const hapusComponent = (parent, index) => {
    let newFieldInputan = fieldInputan[parent];

    newFieldInputan.splice(index, 1);
    Reflect.deleteProperty(dt[parent], [index]);

    setSeed(Math.random());
  };

  const handleChangeSwitch = (status, parent, level, index) => {
    if (level === "level1") {
      setDt({
        ...dt,
        pemohonStatus: parent
      });
    } else if (level === "level2") {
      setDt({
        ...dt,
        pemohonStatus: parent + "&" + index
      });
    }
  };

  const findNameById = (list, key_search) => {
    let searchVal1 = list.find(obj => obj.key === key_search);
    let setVal = "";
    if (searchVal1) {
      setVal = searchVal1.value;
    }

    return setVal;
  };

  const dataManual = (data_parent, level, index) => {
    if (level === "level1") {
      if (
        formData.manualStatus &&
        formData.manualStatus[data_parent] === true
      ) {
        setFormData({
          ...formData,
          manualStatus: {
            ...formData.manualStatus,
            [data_parent]: null
          },
          detailStatus: {
            ...formData.detailStatus,
            [data_parent]: false
          }
        });
      } else {
        setFormData({
          ...formData,
          manualStatus: {
            ...formData.manualStatus,
            [data_parent]: true
          },
          detailStatus: {
            ...formData.detailStatus,
            [data_parent]: true
          }
        });
      }
      setDt({
        ...dt,
        [data_parent]: []
      });
    } else if (level === "level2") {
      if (
        formData.manualStatus &&
        formData.manualStatus[data_parent] &&
        formData.manualStatus[data_parent][index] === true
      ) {
        setFormData({
          ...formData,
          manualStatus: {
            ...formData.manualStatus,
            [data_parent]: {
              ...formData.manualStatus[data_parent],
              [index]: null
            }
          },
          detailStatus: {
            ...formData.detailStatus,
            [data_parent]: {
              ...formData.detailStatus[data_parent],
              [index]: false
            }
          }
        });
      } else {
        setFormData({
          ...formData,
          manualStatus: {
            ...formData.manualStatus,
            [data_parent]: {
              ...formData.manualStatus[data_parent],
              [index]: true
            }
          },
          detailStatus: {
            ...formData.detailStatus,
            [data_parent]: {
              ...formData.detailStatus[data_parent],
              [index]: true
            }
          }
        });
      }
      setDt({
        ...dt,
        [data_parent]: {
          ...dt[data_parent],
          [index]: []
        }
      });
    }
  };

  const simpan = e => {
    e.preventDefault();

    if (kioskMode) {
      props.setLoadingPreview(true);
    } else {
      setAlert({
        loadingPreview: true
      });
    }

    let validasi_form = [];
    let detail_form = [];

    try {
      Object.keys(fieldInputan).map((data_level1, key_level1) => {
        detail_form[data_level1] = [];
        if (fieldInputan[data_level1]) {
          fieldInputan[data_level1].map((data, key) => {
            // #Jika form data dinamis
            if (Array.isArray(data)) {
              detail_form[data_level1][key] = [];

              data.map((data_array2, key2) => {
                // #Jika data tidak array
                if (Array.isArray(dt[data_level1]) === false) {
                  // #convert object to array
                  dt[data_level1] = Object.values(dt[data_level1]);
                  // #convert object to array
                }
                // #Jika data tidak array

                if (dt[data_level1].length > 0) {
                  // #Jika tidak array
                  if (Array.isArray(dt[data_level1][key]) === false) {
                    // #convert object to array
                    dt[data_level1][key] = Object.values(dt[data_level1][key]);
                    // #convert object to array
                  }
                  // #Jika tidak array

                  fieldInputan[data_level1][key][0].map(
                    (data_level2, key_level2) => {
                      detail_form[data_level1][key][key_level2] = {
                        key: data_level2.key,
                        value: ""
                      };

                      dt[data_level1][key].map((data_dt, key_lala) => {
                        if (data_level2.key === data_dt.key) {
                          detail_form[data_level1][key][key_level2] = {
                            key: data_level2.key,
                            value: data_dt.value
                          };
                        }
                      });

                      // #cek value pada array
                      let cekVal = findNameById(
                        dt[data_level1][key],
                        data_level2.key
                      );
                      // #cek value pada array

                      // #set validasi form
                      if (
                        (optionData.dataSurat.jenis_layanan === "Internal" &&
                          data_level1 === "data_penandatangan") ||
                        data_level1 === "data_pembuat"
                      ) {
                        validasi_form.push({
                          parent: `${data_level1 + "_ke_" + (key + 1)}`,
                          name: data_level2.key,
                          status: true
                        });
                      } else {
                        validasi_form.push({
                          parent: `${data_level1 + "_ke_" + (key + 1)}`,
                          name: data_level2.key,
                          status:
                            cekVal || data_level2.required === false
                              ? true
                              : false
                        });
                      }
                      // #set validasi form
                    }
                  );
                }
              });
            }
            // #Jika form data dinamis
            // #Jika form data tidak dinamis
            else {
              // #set detail form dengan data value kosong
              detail_form[data_level1][key] = {
                key: data.key,
                value: ""
              };
              // #set detail form dengan data value kosong

              // #convert object to array
              if (Array.isArray(dt[data_level1]) === false) {
                dt[data_level1] = Object.values(dt[data_level1]);
              }
              // #convert object to array

              if (dt[data_level1].length > 0) {
                dt[data_level1].map((data_dt, key_lala) => {
                  if (data.key === data_dt.key) {
                    detail_form[data_level1][key] = {
                      key: data.key,
                      value: data_dt.value
                    };
                  }
                });

                // #cek value pada array
                let cekVal = findNameById(dt[data_level1], data.key);
                // #cek value pada array

                // #set validasi form
                if (
                  (optionData.dataSurat.jenis_layanan === "Internal" &&
                    data_level1 === "data_penandatangan") ||
                  data_level1 === "data_pembuat"
                ) {
                  validasi_form.push({
                    parent: data_level1,
                    name: data.key,
                    status: true
                  });
                } else {
                  validasi_form.push({
                    parent: data_level1,
                    name: data.key,
                    status: cekVal || data.required === false ? true : false
                  });
                }
                // #set validasi form
              } else {
                detail_form[data_level1][key] = {
                  key: data.key,
                  value: ""
                };

                validasi_form.push({
                  parent: data_level1,
                  name: data.key,
                  status: data.required
                });
              }
            }
            // #Jika form data tidak dinamis
          });
        }
        dt[data_level1] = detail_form[data_level1];
      });

      let cekValidasi = validasi_form.find(element => element.status === false);

      if (cekValidasi) {
        if (kioskMode) {
          props.getAntrian(optionData.dataSurat, "gagal", true);
          props.setLoadingPreview(false);
        } else {
          setAlert({
            loadingPreview: false
          });

          const alertData = {
            show: true,
            basicType: "info",
            basicTitle:
              CapitalizeWord(cekValidasi.parent.replace(/_/g, " ")) +
              " Belum Lengkap",
            pesanAlert:
              "Mohon isi " +
              cekValidasi.name.replace(/_/g, " ") +
              " terlebih dahulu"
          };
          setAlert(alertData);
        }
      } else if (
        dt.pemohonStatus === undefined &&
        optionData.dataSurat.jenis_layanan !== "Internal"
      ) {
        if (kioskMode) {
          props.getAntrian(optionData.dataSurat, "gagal", true);
          props.setLoadingPreview(false);
        } else {
          setAlert({
            loadingPreview: false
          });

          const alertData = {
            show: true,
            basicType: "info",
            basicTitle: "Data Pemohon",
            pesanAlert: "Pilih data pemohon terlebih dahulu"
          };
          setAlert(alertData);
        }
      } else {
        let detail_surat = {};
        let dataDinamis = [];
        let newArrayDinamis = [];

        Object.keys(fieldInputan).map((data_level1, key_level1) => {
          // #set detail surat
          if (fieldInputan[data_level1]) {
            fieldInputan[data_level1].map((data, key) => {
              dataDinamis[data_level1] = [];

              if (Array.isArray(data)) {
                newArrayDinamis[data_level1] = [];

                data.map((data_array2, key2) => {
                  // #convert data to array
                  if (Array.isArray(dt[data_level1][key])) {
                  }
                  // #Object to Array
                  else {
                    dt[data_level1][key] = Object.values(dt[data_level1][key]);
                  }
                  // #end convert data to array

                  dt[data_level1][key].map((data_level2, key_level2) => {
                    // #convert data format
                    if (
                      fieldInputan[data_level1][key][0][key_level2].type ===
                      "currency"
                    ) {
                      dt[data_level1][key][key_level2].value = dt[data_level1][
                        key
                      ][key_level2].value.replace(/[^\d]/g, "");
                    } else if (
                      fieldInputan[data_level1][key][0][key_level2].type ===
                      "date"
                    ) {
                      dt[data_level1][key][key_level2].value = dateFormat(
                        dt[data_level1][key][key_level2].value,
                        "yyyy-mm-dd"
                      );
                    } else if (
                      fieldInputan[data_level1][key][0][key_level2].type ===
                      "datetime"
                    ) {
                      dt[data_level1][key][key_level2].value = dateFormat(
                        dt[data_level1][key][key_level2].value,
                        "yyyy-mm-dd HH:MM:ss"
                      );
                    }
                    // #end convert data format

                    // #set sebagai pemohon
                    if (dt.pemohonStatus === data_level1 + "&" + key) {
                      dt[data_level1][key][key_level2].pemohon = true;
                    } else {
                      dt[data_level1][key][key_level2].pemohon = false;
                    }
                    // #end set sebagai pemohon
                  });
                });

                dt[data_level1].map((data_dt, key_dt) => {
                  newArrayDinamis[data_level1][key_dt] =
                    dt[data_level1][key_dt];
                });

                dataDinamis[data_level1] = newArrayDinamis[data_level1];
                detail_surat[data_level1] = dataDinamis[data_level1];
              } else {
                // #convert data format
                if (data.type === "currency") {
                  dt[data_level1][key].value = dt[data_level1][
                    key
                  ].value.replace(/[^\d]/g, "");
                } else if (data.type === "date") {
                  dt[data_level1][key].value = dateFormat(
                    dt[data_level1][key].value,
                    "yyyy-mm-dd"
                  );
                } else if (data.type === "datetime") {
                  dt[data_level1][key].value = dateFormat(
                    dt[data_level1][key].value,
                    "yyyy-mm-dd HH:MM:ss"
                  );
                }
                // #end convert data format

                // #set sebagai pemohon
                if (dt.pemohonStatus === data_level1) {
                  dt[data_level1][key].pemohon = true;
                } else {
                  dt[data_level1][key].pemohon = false;
                }
                // #end set sebagai pemohon

                // #convert data to array
                if (Array.isArray(dt[data_level1])) {
                  detail_surat[data_level1] = dt[data_level1];
                }
                // #Object to Array
                else {
                  dataDinamis[data_level1] = Object.values(dt[data_level1]);
                  detail_surat[data_level1] = dataDinamis[data_level1];
                }
                // #end convert data to array
              }
            });
          }
          // #end set detail surat
        });

        // # Jika surat internal
        if (optionData.dataSurat.jenis_layanan === "Internal") {
          if (Array.isArray(dt["data_penandatangan"]) === false) {
            dt["data_penandatangan"] = Object.values(dt["data_penandatangan"]);
          }

          let getLoggedData = DataToken(sessionStorage.getItem("access_token"));

          detail_surat["data_pembuat"] = [
            {
              key: "uuid",
              value: getLoggedData.sub.uuid,
              pemohon: false
            }
          ];

          // Kondisi jika dasar surat kosong
          if (fieldInputan.dasar_surat === undefined) {
            detail_surat["dasar_surat"] = [
              {
                key: "dikeluarkan_oleh",
                value: {
                  value: "Desa",
                  label: "Desa"
                },
                pemohon: false
              }
            ];
          }

          if (
            dt.dasar_surat[0] &&
            dt.dasar_surat[0] &&
            dt.dasar_surat[0].value.value === "Kecamatan"
          ) {
            detail_surat["data_penandatangan"] = [];

            dt["data_penandatangan"].map((dt_ttd, key_ttd) => {
              detail_surat["data_penandatangan"] = [
                ...detail_surat["data_penandatangan"],
                {
                  key: dt_ttd.key,
                  value: dt_ttd.key === "jabatan" ? "Camat" : dt_ttd.value,
                  pemohon: false
                }
              ];
            });
          } else {
            detail_surat["data_penandatangan"] = [
              {
                key: "uuid",
                value: formData.ttdSelected.uuid,
                pemohon: false
              },
              {
                key: "jabatan",
                value: formData.ttdSelected.jabatan,
                pemohon: false
              },
              {
                key: "nama",
                value: formData.ttdSelected.nama,
                pemohon: false
              },
              {
                key: "nip",
                value: formData.ttdSelected.nip,
                pemohon: false
              },
              {
                key: "golongan",
                value: "",
                pemohon: false
              }
            ];
          }
        }

        let bodyRaw = {
          uuid: dt.uuid,
          id_jenis: dt.id_jenis,
          detail_surat: JSON.stringify(detail_surat)
        };

        if (dt.uuid === "") {
          if (kioskMode) {
            bodyRaw.id_jenis = props.id_jenis;
          } else {
            bodyRaw.id_jenis = props.location.state.uuid;
          }
        }

        let psn = "";
        let resstat = 204;
        let metode = "create";
        if (bodyRaw.uuid === "") {
          psn = "Tambah";
          resstat = 201;
          bodyRaw.uuid = null;
        } else {
          psn = "Ubah";
          resstat = 200;
          metode = "update";
        }

        Post("generate-form/" + metode, bodyRaw.uuid, bodyRaw, res => {
          // For testing
          if (props.resSubmit) {
            props.resSubmit(res.status);
          }
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              btnForm: false,
              form: false
            }
          });
          setIsOpen(false);

          if (kioskMode) {
            if (res.status === resstat) {
              let dataAntrian = {
                nama: props.data.results.nama,
                nik: props.data.results.id,
                keterangan: "",
                uuid_surat: res.data.results.uuid_surat,
                kode_surat: res.data.results.kode_surat
              };
              // Set Data Surat
              props.getDataSurat(res.data.results);

              setTimeout(
                function() {
                  Get(
                    "persetujuan/kiosk/" +
                      dataAntrian.uuid_surat +
                      "/" +
                      props.id_jenis,
                    null,
                    res2 => {
                      props.setLoadingPreview(false);

                      if (res2.code === 201) {
                        props.getAntrian(
                          optionData.dataSurat,
                          "berhasil",
                          false,
                          dataAntrian
                        );
                      } else {
                        props.getAntrian(optionData.dataSurat, "gagal");
                      }
                    }
                  );
                }.bind(this),
                1000
              );
            } else {
              props.setLoadingPreview(false);
              props.getAntrian(optionData.dataSurat, "gagal");
            }
          } else {
            if (res.status === resstat) {
              const alertData = {
                get_data_surat: {
                  uuid_surat: res.data.results.uuid_surat,
                  kode_surat: res.data.results.kode_surat
                },
                status: {
                  frmPreviewDraft: true,
                  jenis_form: psn
                }
              };
              setAlert({
                loadingPreview: false
              });
              setAlert(alertData);
            } else {
              const alertData = {
                show: true,
                basicType: "danger",
                basicTitle: "Data " + props.location.state.nama_surat,
                pesanAlert: "Gagal " + psn + " Data"
              };
              setAlert({
                loadingPreview: false
              });
              setAlert(alertData);
            }

            // Refresh list
            setStatusRefresh(true);
          }
        });
      }
    } catch (e) {
      // console.log('Error')
      // console.log(e)
      // #jika kiosk
      if (kioskMode) {
        props.getAntrian(optionData.dataSurat, "gagal", true);
        props.setLoadingPreview(false);
      }
      // #jika tidak kiosk
      else {
        setAlert({
          loadingPreview: false
        });

        const alertData = {
          show: true,
          basicType: "danger",
          basicTitle: "Terjadi Kesalahan",
          pesanAlert: "Siilahkan hubungi admin"
        };
        setAlert(alertData);
      }
    }
  };

  const rupiah = number => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR"
    }).format(number);
  };

  const getFilePreview = (url) => {
			
		setAlert({
      loadingPreview: true
    });

		const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null

    setAlert({
      loadingPreview: false
    });
	}

  return (
    <Modal
      classNames={{ overlay: "card-scrollable" }}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      style={{
        maxwidth: "unset"
      }}
    >
      <Form
        id="modalForm"
        data-testid="form-create"
        className="theme-form"
        onSubmit={simpan}
      >
        <div
        // onMouseDown={(e) => {
        // 	let slider = document.querySelector('.card-scrollable');
        // 	setDraggable({
        // 		isDown: true,
        // 		startY: e.pageY - slider.offsetTop,
        // 		scrollUp: slider.scrollTop,
        // 	})
        // }}
        // onMouseLeave={() => {
        // 	setDraggable({
        // 		...draggable,
        // 		isDown: false
        // 	})
        // }}
        // onMouseUp={() => {
        // 	setDraggable({
        // 		...draggable,
        // 		isDown: false
        // 	})
        // }}
        // onMouseMove={(e) => {
        // 	e.preventDefault();

        // 	let slider = document.querySelector('.card-scrollable');

        // 	if (!draggable.isDown) {
        // 		return;
        // 	}

        // 	const y = e.pageY - slider.offsetTop;
        // 	const startY = draggable.startY;
        // 	const walk = y - startY;
        // 	slider.scrollTop = draggable.scrollUp - walk;
        // }}
        >
          <div className="modal-header">
            <h5 className="modal-title">
              {formData.status.frmDetailPengajuan
                ? "Detail"
                : statusData === "create"
                ? "Tambah"
                : "Edit"}{" "}
              {optionData.dataSurat ? optionData.dataSurat.nama_surat : ""}
            </h5>
          </div>
          <div className="modal-body">
            <p>
              Data identitas akan terisi secara otomatis saat NIK dipilih. Jika
              ada ketidak sesuaian data, silakan ubah di data master penduduk.
            </p>
            <input
              className="form-control"
              id="uuid"
              type="hidden"
              placeholder=""
              defaultValue={dt && dt.uuid ? dt.uuid : ""}
            />

            {fieldInputan ? (
              Object.keys(fieldInputan).map(data_level1 => {
                let sectionData = data_level1.replace(/_/g, " ");
                return fieldInputan[data_level1] &&
                  fieldInputan[data_level1].length !== 0 &&
                  data_level1 !== "data_pembuat" &&
                  data_level1 !== "data_penandatangan" ? (
                  <>
                    <div
                      style={{
                        backgroundColor: "grey",
                        paddingTop: "15px",
                        paddingBottom: "15px",
                        paddingLeft: "15px",
                        color: "white",
                        marginBottom: "15px",
                        textTransform: "capitalize"
                      }}
                    >
                      <b>{sectionData}</b>
                    </div>
                    {fieldInputan[data_level1].map((data, key) => {
                      let cekType = Array.isArray(data);
                        if (cekType === false) {
                          return (
                            <>
                              {data.type === "nik" ? (
                                <>
                                  <FormGroup className="row">
                                    {formData.status.frmDetailPengajuan ? (
                                      <>
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            <input
                                              name={data.key}
                                              className="form-control"
                                              id={data.key}
                                              type="text"
                                              inputMode="numeric"
                                              pattern="[0-9\s]{16,16}"
                                              minlength="16"
                                              maxlength="16"
                                              placeholder={
                                                "Masukkan " + data.label
                                              }
                                              defaultValue={
                                                dt[data_level1] &&
                                                dt[data_level1][key] &&
                                                dt[data_level1][key].value
                                                  ? dt[data_level1][key].value
                                                      .value
                                                  : ""
                                              }
                                              style={{
                                                backgroundColor: "#c9d1d8"
                                              }}
                                              disabled
                                            />
                                          </div>
                                        </Col>
                                      </>
                                    ) : (
                                      <>
                                        <Col sm="9">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.manualStatus &&
                                            formData.manualStatus[
                                              data_level1
                                            ] ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9\s]{16,16}"
                                                minlength="16"
                                                maxlength="16"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                        .value
                                                    : ""
                                                }
                                                onChange={e =>
                                                  handleChangeInputText(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  )
                                                }
                                                // required
                                              />
                                            ) : (
                                              <Select
                                                classNamePrefix="select"
                                                onChange={e => {
                                                  getPenduduk(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    "",
                                                    ""
                                                  );
                                                }}
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                name={dt[data.key]}
                                                options={
                                                  formData.formSelectPenduduk &&
                                                  formData.formSelectPenduduk[
                                                    data_level1
                                                  ] &&
                                                  formData.formSelectPenduduk[
                                                    data_level1
                                                  ][data.key]
                                                    ? formData
                                                        .formSelectPenduduk[
                                                        data_level1
                                                      ][data.key]
                                                    : []
                                                }
                                                placeholder={
                                                  "Pilih " + data.label
                                                }
                                                onInputChange={e =>
                                                  handleChangeInputNIK(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    data.model,
                                                    "level1",
                                                    key
                                                  )
                                                }
                                                isClearable
                                                // required
                                              />
                                            )}
                                          </div>
                                          <br />
                                          <small
                                            id="emailHelp"
                                            className="form-text text-muted mb-3"
                                          >
                                            Data NIK{" "}
                                            {formData.manualStatus &&
                                            formData.manualStatus[
                                              data_level1
                                            ] === true
                                              ? ""
                                              : "tidak"}{" "}
                                            tersedia?{" "}
                                            <span
                                              style={{
                                                cursor: "pointer",
                                                color: "#0000ff"
                                              }}
                                              onClick={() => {
                                                dataManual(
                                                  data_level1,
                                                  "level1",
                                                  ""
                                                );
                                              }}
                                            >
                                              Klik disini
                                            </span>
                                          </small>
                                        </Col>
                                        <Col sm="3">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>Jadikan Pemohon</b>
                                          </Label>
                                          <div
                                            data-testid="selectNIK"
                                            key={seed}
                                          >
                                            <Switch
                                              onChange={e => {
                                                handleChangeSwitch(
                                                  e,
                                                  data_level1,
                                                  "level1",
                                                  ""
                                                );
                                              }}
                                              checked={
                                                dt.pemohonStatus &&
                                                dt.pemohonStatus === data_level1
                                                  ? true
                                                  : false
                                              }
                                              disabled={
                                                formData.manualStatus &&
                                                formData.manualStatus[
                                                  data_level1
                                                ] === true
                                                  ? true
                                                  : false
                                              }
                                            />
                                          </div>
                                        </Col>
                                      </>
                                    )}
                                  </FormGroup>
                                </>
                              ) : data.type === "perangkat" ? (
                                <>
                                  <FormGroup className="row">
                                    <Col sm="12">
                                      <Label
                                        className="col-form-label"
                                        htmlFor="nik"
                                      >
                                        <b>{data.label}</b>
                                      </Label>
                                      <div data-testid="selectNIK">
                                        <Select
                                          classNamePrefix="select"
                                          onChange={e => {
                                            getPerangkat(
                                              e,
                                              data.key,
                                              data_level1,
                                              "level1",
                                              "",
                                              ""
                                            );
                                          }}
                                          defaultValue={
                                            dt[data_level1] &&
                                            dt[data_level1][key] &&
                                            dt[data_level1][key].value
                                              ? dt[data_level1][key].value
                                              : ""
                                          }
                                          value={
                                            dt[data_level1] &&
                                            dt[data_level1][key] &&
                                            dt[data_level1][key].value
                                              ? dt[data_level1][key].value
                                              : ""
                                          }
                                          name={dt[data.key]}
                                          options={
                                            formData.formSelect &&
                                            formData.formSelect[data_level1] &&
                                            formData.formSelect[data_level1][
                                              data.key
                                            ]
                                              ? formData.formSelect[
                                                  data_level1
                                                ][data.key]
                                              : []
                                          }
                                          placeholder={"Pilih " + data.label}
                                          onInputChange={e =>
                                            handleChangeInputNIK(
                                              e,
                                              data.key,
                                              data_level1,
                                              data.model,
                                              "level1",
                                              key
                                            )
                                          }
                                          isClearable
                                          // required
                                        />
                                      </div>
                                      <br />
                                    </Col>
                                  </FormGroup>
                                </>
                              ) : formData.detailStatus[data_level1] ? (
                                <>
                                  {data.type === "text" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                onChange={e =>
                                                  handleChangeInputText(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  )
                                                }
                                                // required
                                                readOnly={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? { backgroundColor: "" }
                                                    : {
                                                        backgroundColor:
                                                          "#c9d1d8"
                                                      }
                                                }
                                              />
                                            )}
                                          </div>
                                          {data.key === "alamat" ? (
                                            formData.status
                                              .frmDetailPengajuan ? (
                                              ""
                                            ) : formData.manualStatus &&
                                              formData.manualStatus[
                                                data_level1
                                              ] === false ? (
                                              <small>
                                                <font color="red">
                                                  * Jika data wilayah kosong,
                                                  silahkan perbaiki data alamat
                                                  kartu keluarga dan pastikan
                                                  data lengkap terlebih dahulu
                                                </font>
                                              </small>
                                            ) : (
                                              <small>
                                                <font color="red">
                                                  *{" "}
                                                  {"Contoh: RT. 002/RW. 001, Dusun 1, " +
                                                    Nama_DESA +
                                                    ", Kec. ABC, Kab. ABC"}
                                                </font>
                                              </small>
                                            )
                                          ) : (
                                            <></>
                                          )}
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "textarea" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <textarea
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                rows={5}
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <textarea
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                rows={5}
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                onChange={e =>
                                                  handleChangeInputText(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  )
                                                }
                                                // required
                                                readOnly={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={{
                                                  backgroundColor:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? ""
                                                      : "#c9d1d8"
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "number" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="number"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                minLength={
                                                  data.key === "nik"
                                                    ? 16
                                                    : data.min_length
                                                }
                                                maxLength={
                                                  data.key === "nik"
                                                    ? 16
                                                    : data.max_length
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="number"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                onChange={e =>
                                                  handleChangeInputText(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  )
                                                }
                                                minLength={
                                                  data.key === "nik"
                                                    ? 16
                                                    : data.min_length
                                                }
                                                maxLength={
                                                  data.key === "nik"
                                                    ? 16
                                                    : data.max_length
                                                }
                                                // required
                                                readOnly={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={{
                                                  backgroundColor:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? ""
                                                      : "#c9d1d8"
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "text_number" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                inputMode="numeric"
                                                pattern={`${"[0-9s]" +
                                                  "{" +
                                                  data.min_length +
                                                  "," +
                                                  data.max_length}}`}
                                                minLength={data.min_length}
                                                maxLength={data.max_length}
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                inputMode="numeric"
                                                pattern={`${"[0-9s]" +
                                                  "{" +
                                                  data.min_length +
                                                  "," +
                                                  data.max_length}}`}
                                                minLength={data.min_length}
                                                maxLength={data.max_length}
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                onChange={e =>
                                                  handleChangeInputText(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  )
                                                }
                                                // required
                                                readOnly={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={{
                                                  backgroundColor:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? ""
                                                      : "#c9d1d8"
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "select" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value &&
                                                  dt[data_level1][key].value
                                                    .label
                                                    ? dt[data_level1][key].value
                                                        .label
                                                    : ""
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <Select
                                                classNamePrefix="select"
                                                onChange={e => {
                                                  handleChangeSelect(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  );
                                                }}
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                name={data.key}
                                                options={
                                                  formData.formSelect
                                                    ? formData.formSelect[
                                                        data.key
                                                      ]
                                                    : []
                                                }
                                                placeholder={
                                                  "Pilih " + data.label
                                                }
                                                isClearable
                                                // required
                                                isDisabled={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={{
                                                  backgroundColor:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? ""
                                                      : "#c9d1d8"
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "date" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="date"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <Datetime
                                                inputProps={{
                                                  placeholder: data.label,
                                                  disabled:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? false
                                                      : true
                                                  // required: true
                                                }}
                                                name={data.key}
                                                locale="id-ID"
                                                timeFormat={false}
                                                dateFormat="DD/MM/yyyy"
                                                input={true}
                                                closeOnTab={true}
                                                initialValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? new Date(
                                                        dt[data_level1][
                                                          key
                                                        ].value
                                                      )
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? new Date(
                                                        dt[data_level1][
                                                          key
                                                        ].value
                                                      )
                                                    : ""
                                                }
                                                onChange={e => {
                                                  if (
                                                    typeof e.isValid !==
                                                      "undefined" &&
                                                    e._isValid
                                                  ) {
                                                    setDt({
                                                      ...dt,
                                                      [data_level1]: {
                                                        ...dt[data_level1],
                                                        [key]: {
                                                          ...dt[data_level1][
                                                            key
                                                          ],
                                                          key: data.key,
                                                          value: e.format(
                                                            "YYYY/MM/DD"
                                                          )
                                                        }
                                                      }
                                                    });
                                                  }
                                                }}
                                                readOnly={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={{
                                                  backgroundColor:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? ""
                                                      : "#c9d1d8"
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "datetime" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <Datetime
                                                inputProps={{
                                                  placeholder: data.label,
                                                  // required: true
                                                  disabled:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? false
                                                      : true
                                                }}
                                                name={data.key}
                                                locale="id-ID"
                                                timeFormat="HH:mm"
                                                dateFormat="DD/MM/yyyy"
                                                input={true}
                                                closeOnTab={true}
                                                initialValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? new Date(
                                                        dt[data_level1][
                                                          key
                                                        ].value
                                                      )
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? new Date(
                                                        dt[data_level1][
                                                          key
                                                        ].value
                                                      )
                                                    : ""
                                                }
                                                onChange={e => {
                                                  if (
                                                    typeof e.isValid !==
                                                      "undefined" &&
                                                    e._isValid
                                                  ) {
                                                    let tgl = e.format(
                                                      "YYYY-MM-DD HH:mm:ss"
                                                    );

                                                    setDt({
                                                      ...dt,
                                                      [data_level1]: {
                                                        ...dt[data_level1],
                                                        [key]: {
                                                          ...dt[data_level1][
                                                            key
                                                          ],
                                                          key: data.key,
                                                          value: new Date(tgl)
                                                        }
                                                      }
                                                    });
                                                  }
                                                }}
                                                readOnly={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={{
                                                  backgroundColor:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? ""
                                                      : "#c9d1d8"
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "currency" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          <div data-testid="selectNIK">
                                            {formData.status
                                              .frmDetailPengajuan ? (
                                              <input
                                                name={data.key}
                                                className="form-control"
                                                id={data.key}
                                                type="text"
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? rupiah(
                                                        dt[data_level1][key]
                                                          .value
                                                      )
                                                    : ""
                                                }
                                                style={{
                                                  backgroundColor: "#c9d1d8"
                                                }}
                                                disabled
                                              />
                                            ) : (
                                              <NumberFormat
                                                data-testid="nominal penghasilan"
                                                id={data.key}
                                                name={data.key}
                                                placeholder={
                                                  "Masukkan " + data.label
                                                }
                                                thousandSeparator={true}
                                                prefix={"Rp. "}
                                                className="form-control"
                                                defaultValue={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                value={
                                                  dt[data_level1] &&
                                                  dt[data_level1][key] &&
                                                  dt[data_level1][key].value
                                                    ? dt[data_level1][key].value
                                                    : ""
                                                }
                                                onChange={e =>
                                                  handleChangeInputText(
                                                    e,
                                                    data.key,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  )
                                                }
                                                // required
                                                readOnly={
                                                  formData.manualStatus &&
                                                  formData.manualStatus[
                                                    data_level1
                                                  ] === true
                                                    ? false
                                                    : true
                                                }
                                                style={{
                                                  backgroundColor:
                                                    formData.manualStatus &&
                                                    formData.manualStatus[
                                                      data_level1
                                                    ] === true
                                                      ? ""
                                                      : "#c9d1d8"
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : data.type === "image" ||
                                    data.type === "file" ? (
                                    <>
                                      <FormGroup className="row">
                                        <Col sm="12">
                                          <Label
                                            className="col-form-label"
                                            htmlFor="nik"
                                          >
                                            <b>{data.label}</b>
                                          </Label>
                                          {loads ? (
                                            <div className="row">
                                              <div
                                                className="col-sm-12"
                                                align="center"
                                              >
                                                <img
                                                  alt="loading"
                                                  src={require("../../../assets/images/tes-loading.gif")}
                                                  style={{
                                                    borderRadius: "10px",
                                                    width: "100px"
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          ) : 
                                            statusData === "detail"
                                            ?
                                              <div className="row">
                                                <div className="col-12" align="center">
                                                  {
                                                    data.type === "image" ? (
                                                      <img
                                                        src={dt[data_level1] && dt[data_level1][key]? dt[data_level1][key].value : ''}
                                                        style={{
                                                          width: "470px",
                                                          marginBottom: '20px'
                                                        }}
                                                        alt=""
                                                      />
                                                    ) : (
                                                      <img
                                                        src={require("../../../assets/images/file-icon.png")}
                                                        style={{
                                                          width:"270px",
                                                        }}
                                                        alt=""
                                                      />
                                                    )
                                                  }
                                                </div>
                                                <div className="col-12 mt-4" align="center">
                                                  <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={() => {
                                                      getFilePreview(dt[data_level1][key].value)
                                                    }}
                                                  >
                                                    Download
                                                  </button>
                                                </div>
                                              </div>
                                            :
                                              (
                                              <Dropzone
                                                onDrop={acceptedFiles =>
                                                  processGbr(
                                                    acceptedFiles,
                                                    data.key,
                                                    data.type,
                                                    data_level1,
                                                    "level1",
                                                    key,
                                                    ""
                                                  )
                                                }
                                                maxFiles={12}
                                              >
                                                {({
                                                  getRootProps,
                                                  getInputProps
                                                }) => (
                                                  <section>
                                                    <div
                                                      {...getRootProps()}
                                                      style={{
                                                        minHeight: "100px",
                                                        paddingTop: "40px",
                                                        padding:
                                                          "5px 5px 5px 5px",
                                                        border:
                                                          "1px solid #d2d2d2"
                                                      }}
                                                    >
                                                      <input
                                                        {...getInputProps()}
                                                      />
                                                      <div
                                                        style={{
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center"
                                                        }}
                                                      >
                                                        <p className="text-center">
                                                          {dt[data_level1] &&
                                                          dt[data_level1][key] &&
                                                          dt[data_level1][key]
                                                            .value ? (
                                                            data.type ===
                                                            "image" ? (
                                                              <img
                                                                src={
                                                                  dt[data_level1][
                                                                    key
                                                                  ].value
                                                                }
                                                                style={{
                                                                  width: "470px"
                                                                }}
                                                                alt=""
                                                              />
                                                            ) : (
                                                              <img
                                                                src={require("../../../assets/images/file-icon.png")}
                                                                style={{
                                                                  width: "270px"
                                                                }}
                                                                alt=""
                                                              />
                                                            )
                                                          ) : (
                                                            <Label
                                                              className="col-form-label text-center"
                                                              htmlFor="inputEmail3"
                                                            >
                                                              Drag 'n' drop some
                                                              files here, or click
                                                              to select files
                                                            </Label>
                                                          )}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </section>
                                                )}
                                              </Dropzone>
                                            )
                                          }
                                        </Col>
                                      </FormGroup>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          );
                        } else {
                          return (
                            <>
                              {key === 0 ? (
                                formData.status.frmDetailPengajuan ? (
                                  ""
                                ) : (
                                  <div>
                                    <FormGroup className="row">
                                      <Col sm="12">
                                        <button
                                          type="button"
                                          className="btn btn-secondary"
                                          onClick={() => {
                                            tambahComponent(data_level1);
                                          }}
                                        >
                                          Tambah {sectionData}
                                        </button>
                                      </Col>
                                    </FormGroup>
                                  </div>
                                )
                              ) : (
                                ""
                              )}
                              <div key={seed}>
                                {data.map((data_array, key_array) => {
                                  return (
                                    <>
                                      <div
                                        style={{
                                          paddingTop: "15px",
                                          paddingBottom: "15px",
                                          marginTop: "-10px",
                                          marginBottom: "15px",
                                          textTransform: "capitalize",
                                          borderBottom: "1px solid black"
                                        }}
                                      >
                                        <b>
                                          {sectionData} ke - {key + 1}
                                        </b>
                                      </div>
                                      {data_array.map((data2, key2) => {
                                        return (
                                          <>
                                            {data2.type === "nik" ? (
                                              <>
                                                {formData.status
                                                  .frmDetailPengajuan ? (
                                                  <FormGroup className="row">
                                                    <Col sm="12">
                                                      <Label
                                                        className="col-form-label"
                                                        htmlFor="nik"
                                                      >
                                                        <b>{data2.label}</b>
                                                      </Label>
                                                      <div data-testid="selectNIK">
                                                        <input
                                                          name={data2.key}
                                                          className="form-control"
                                                          id={data2.key}
                                                          type="text"
                                                          placeholder={
                                                            "Masukkan " +
                                                            data2.label
                                                          }
                                                          defaultValue={
                                                            dt[data_level1] &&
                                                            dt[data_level1][
                                                              key
                                                            ] &&
                                                            dt[data_level1][
                                                              key
                                                            ][key2] &&
                                                            dt[data_level1][
                                                              key
                                                            ][key2].value
                                                              ? dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  .value
                                                              : ""
                                                          }
                                                          style={{
                                                            backgroundColor:
                                                              "#c9d1d8"
                                                          }}
                                                          disabled
                                                        />
                                                      </div>
                                                    </Col>
                                                  </FormGroup>
                                                ) : (
                                                  <FormGroup className="row">
                                                    <Col sm="9">
                                                      <Label
                                                        className="col-form-label"
                                                        htmlFor="nik"
                                                      >
                                                        <b>{data2.label}</b>
                                                      </Label>
                                                      <div data-testid="selectNIK">
                                                        {formData.manualStatus &&
                                                        formData.manualStatus[
                                                          data_level1
                                                        ] &&
                                                        formData.manualStatus[
                                                          data_level1
                                                        ][key] ? (
                                                          <input
                                                            name={data2.key}
                                                            className="form-control"
                                                            id={data2.key}
                                                            type="text"
                                                            inputMode="numeric"
                                                            pattern="[0-9\s]{16,16}"
                                                            minlength="16"
                                                            maxlength="16"
                                                            placeholder={
                                                              "Masukkan " +
                                                              data2.label
                                                            }
                                                            defaultValue={
                                                              dt[data_level1] &&
                                                              dt[data_level1][
                                                                key
                                                              ] &&
                                                              dt[data_level1][
                                                                key
                                                              ][key2] &&
                                                              dt[data_level1][
                                                                key
                                                              ][key2].value
                                                                ? dt[
                                                                    data_level1
                                                                  ][key][key2]
                                                                    .value.value
                                                                : ""
                                                            }
                                                            onChange={e =>
                                                              handleChangeInputText(
                                                                e,
                                                                data2.key,
                                                                data_level1,
                                                                "level2",
                                                                key,
                                                                key2
                                                              )
                                                            }
                                                            // required
                                                          />
                                                        ) : (
                                                          <Select
                                                            classNamePrefix="select"
                                                            onChange={e => {
                                                              getPenduduk(
                                                                e,
                                                                data2.key,
                                                                data_level1,
                                                                "level2",
                                                                key,
                                                                key2
                                                              );
                                                            }}
                                                            defaultValue={
                                                              dt[data_level1] &&
                                                              dt[data_level1][
                                                                key
                                                              ] &&
                                                              dt[data_level1][
                                                                key
                                                              ][key2] &&
                                                              dt[data_level1][
                                                                key
                                                              ][key2].value
                                                                ? dt[
                                                                    data_level1
                                                                  ][key][key2]
                                                                    .value
                                                                : ""
                                                            }
                                                            value={
                                                              dt[data_level1] &&
                                                              dt[data_level1][
                                                                key
                                                              ] &&
                                                              dt[data_level1][
                                                                key
                                                              ][key2] &&
                                                              dt[data_level1][
                                                                key
                                                              ][key2].value
                                                                ? dt[
                                                                    data_level1
                                                                  ][key][key2]
                                                                    .value
                                                                : ""
                                                            }
                                                            name={dt[data2.key]}
                                                            options={
                                                              formData.formSelectPenduduk &&
                                                              formData
                                                                .formSelectPenduduk[
                                                                data_level1
                                                              ] &&
                                                              formData
                                                                .formSelectPenduduk[
                                                                data_level1
                                                              ][key] &&
                                                              formData
                                                                .formSelectPenduduk[
                                                                data_level1
                                                              ][key][data2.key]
                                                                ? formData
                                                                    .formSelectPenduduk[
                                                                    data_level1
                                                                  ][key][
                                                                    data2.key
                                                                  ]
                                                                : []
                                                            }
                                                            placeholder={
                                                              "Pilih " +
                                                              data2.label
                                                            }
                                                            onInputChange={e =>
                                                              handleChangeInputNIK(
                                                                e,
                                                                data2.key,
                                                                data_level1,
                                                                data2.model,
                                                                "level2",
                                                                key
                                                              )
                                                            }
                                                            isClearable
                                                            // required
                                                          />
                                                        )}
                                                      </div>
                                                      <br />
                                                      <small
                                                        id="emailHelp"
                                                        className="form-text text-muted mb-3"
                                                      >
                                                        Data NIK{" "}
                                                        {formData.manualStatus &&
                                                        formData.manualStatus[
                                                          data_level1
                                                        ] &&
                                                        formData.manualStatus[
                                                          data_level1
                                                        ][key] === true
                                                          ? ""
                                                          : "tidak"}{" "}
                                                        tersedia?{" "}
                                                        <span
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "#0000ff"
                                                          }}
                                                          onClick={() => {
                                                            dataManual(
                                                              data_level1,
                                                              "level2",
                                                              key
                                                            );
                                                          }}
                                                        >
                                                          Klik disini
                                                        </span>
                                                      </small>
                                                    </Col>
                                                    <Col sm="3">
                                                      <Label
                                                        className="col-form-label"
                                                        htmlFor="nik"
                                                      >
                                                        <b>Jadikan Pemohon</b>
                                                      </Label>
                                                      <div
                                                        data-testid="selectNIK"
                                                        key={seed}
                                                      >
                                                        <Switch
                                                          onChange={e => {
                                                            handleChangeSwitch(
                                                              e,
                                                              data_level1,
                                                              "level2",
                                                              key
                                                            );
                                                          }}
                                                          checked={
                                                            dt.pemohonStatus &&
                                                            dt.pemohonStatus ===
                                                              data_level1 +
                                                                "&" +
                                                                key
                                                              ? true
                                                              : false
                                                          }
                                                          disabled={
                                                            formData.manualStatus &&
                                                            formData
                                                              .manualStatus[
                                                              data_level1
                                                            ] &&
                                                            formData
                                                              .manualStatus[
                                                              data_level1
                                                            ][key] === true
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                      </div>
                                                    </Col>
                                                  </FormGroup>
                                                )}
                                              </>
                                            ) : data2.type === "perangkat" ? (
                                              <>
                                                <FormGroup className="row">
                                                  <Col sm="12">
                                                    <Label
                                                      className="col-form-label"
                                                      htmlFor="nik"
                                                    >
                                                      <b>{data2.label}</b>
                                                    </Label>
                                                    <div data-testid="selectNIK">
                                                      <Select
                                                        classNamePrefix="select"
                                                        onChange={e => {
                                                          getPerangkat(
                                                            e,
                                                            data2.key,
                                                            data_level1,
                                                            "level2",
                                                            key,
                                                            key2
                                                          );
                                                        }}
                                                        defaultValue={
                                                          dt[data_level1] &&
                                                          dt[data_level1][
                                                            key
                                                          ] &&
                                                          dt[data_level1][key][
                                                            key2
                                                          ] &&
                                                          dt[data_level1][key][
                                                            key2
                                                          ].value
                                                            ? dt[data_level1][
                                                                key
                                                              ][key2].value
                                                            : ""
                                                        }
                                                        value={
                                                          dt[data_level1] &&
                                                          dt[data_level1][
                                                            key
                                                          ] &&
                                                          dt[data_level1][key][
                                                            key2
                                                          ] &&
                                                          dt[data_level1][key][
                                                            key2
                                                          ].value
                                                            ? dt[data_level1][
                                                                key
                                                              ][key2].value
                                                            : ""
                                                        }
                                                        name={dt[data2.key]}
                                                        options={
                                                          formData.formSelect &&
                                                          formData.formSelect[
                                                            data_level1
                                                          ] &&
                                                          formData.formSelect[
                                                            data_level1
                                                          ][key] &&
                                                          formData.formSelect[
                                                            data_level1
                                                          ][key][data2.key]
                                                            ? formData
                                                                .formSelect[
                                                                data_level1
                                                              ][key][data2.key]
                                                            : []
                                                        }
                                                        placeholder={
                                                          "Pilih " + data2.label
                                                        }
                                                        onInputChange={e =>
                                                          handleChangeInputNIK(
                                                            e,
                                                            data2.key,
                                                            data_level1,
                                                            data2.model,
                                                            "level2",
                                                            key
                                                          )
                                                        }
                                                        isClearable
                                                        // required
                                                      />
                                                    </div>
                                                  </Col>
                                                </FormGroup>
                                              </>
                                            ) : formData.detailStatus[
                                                data_level1
                                              ] &&
                                              formData.detailStatus[
                                                data_level1
                                              ][key] ? (
                                              <>
                                                {data2.type === "text" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {/* data_level1, key, key2 */}
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              onChange={e =>
                                                                handleChangeInputText(
                                                                  e,
                                                                  data2.key,
                                                                  data_level1,
                                                                  "level2",
                                                                  key,
                                                                  key2
                                                                )
                                                              }
                                                              // required
                                                              readOnly={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                        {data2.key ===
                                                        "alamat" ? (
                                                          formData.status
                                                            .frmDetailPengajuan ? (
                                                            ""
                                                          ) : formData.manualStatus &&
                                                            formData
                                                              .manualStatus[
                                                              data_level1
                                                            ] &&
                                                            formData
                                                              .manualStatus[
                                                              data_level1
                                                            ][key] === false ? (
                                                            <small>
                                                              <font color="red">
                                                                * Jika data
                                                                wilayah kosong,
                                                                silahkan
                                                                perbaiki data
                                                                alamat kartu
                                                                keluarga dan
                                                                pastikan data
                                                                lengkap terlebih
                                                                dahulu
                                                              </font>
                                                            </small>
                                                          ) : (
                                                            <small>
                                                              <font color="red">
                                                                *{" "}
                                                                {"Contoh: RT. 002/RW. 001, Dusun 1, " +
                                                                  Nama_DESA +
                                                                  ", Kec. ABC, Kab. ABC"}
                                                              </font>
                                                            </small>
                                                          )
                                                        ) : (
                                                          <></>
                                                        )}
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type ===
                                                  "textarea" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <textarea
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              rows={5}
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <textarea
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              rows={5}
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              onChange={e =>
                                                                handleChangeInputText(
                                                                  e,
                                                                  data2.key,
                                                                  data_level1,
                                                                  "level2",
                                                                  key,
                                                                  key2
                                                                )
                                                              }
                                                              // required
                                                              readOnly={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type === "number" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="number"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              minLength={
                                                                data2.key ===
                                                                "nik"
                                                                  ? 16
                                                                  : data2.min_length
                                                              }
                                                              maxLength={
                                                                data2.key ===
                                                                "nik"
                                                                  ? 16
                                                                  : data2.max_length
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="number"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              onChange={e =>
                                                                handleChangeInputText(
                                                                  e,
                                                                  data2.key,
                                                                  data_level1,
                                                                  "level2",
                                                                  key,
                                                                  key2
                                                                )
                                                              }
                                                              minLength={
                                                                data2.key ===
                                                                "nik"
                                                                  ? 16
                                                                  : data2.min_length
                                                              }
                                                              maxLength={
                                                                data2.key ===
                                                                "nik"
                                                                  ? 16
                                                                  : data2.max_length
                                                              }
                                                              // required
                                                              readOnly={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type ===
                                                  "text_number" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              inputMode="numeric"
                                                              pattern={`${"[0-9s]" +
                                                                "{" +
                                                                data2.min_length +
                                                                "," +
                                                                data2.max_length}}`}
                                                              minLength={
                                                                data2.min_length
                                                              }
                                                              maxLength={
                                                                data2.max_length
                                                              }
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              inputMode="numeric"
                                                              pattern={`${"[0-9s]" +
                                                                "{" +
                                                                data2.min_length +
                                                                "," +
                                                                data2.max_length}}`}
                                                              minLength={
                                                                data2.min_length
                                                              }
                                                              maxLength={
                                                                data2.max_length
                                                              }
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              onChange={e =>
                                                                handleChangeInputText(
                                                                  e,
                                                                  data2.key,
                                                                  data_level1,
                                                                  "level2",
                                                                  key,
                                                                  key2
                                                                )
                                                              }
                                                              // required
                                                              readOnly={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type === "select" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  .label
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                      .label
                                                                  : ""
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <Select
                                                              classNamePrefix="select"
                                                              onChange={e => {
                                                                handleChangeSelect(
                                                                  e,
                                                                  data2.key,
                                                                  data_level1,
                                                                  "level2",
                                                                  key,
                                                                  key2
                                                                );
                                                              }}
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              name={data2.key}
                                                              options={
                                                                formData.formSelect
                                                                  ? formData
                                                                      .formSelect[
                                                                      data2.key
                                                                    ]
                                                                  : []
                                                              }
                                                              placeholder={
                                                                "Pilih " +
                                                                data2.label
                                                              }
                                                              isClearable
                                                              // required
                                                              isDisabled={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type === "date" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="date"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <Datetime
                                                              inputProps={{
                                                                placeholder:
                                                                  data2.label,
                                                                disabled:
                                                                  formData.manualStatus &&
                                                                  formData
                                                                    .manualStatus[
                                                                    data_level1
                                                                  ] &&
                                                                  formData
                                                                    .manualStatus[
                                                                    data_level1
                                                                  ][key] ===
                                                                    true
                                                                    ? false
                                                                    : true
                                                                // required: true
                                                              }}
                                                              name={data2.key}
                                                              locale="id-ID"
                                                              timeFormat={false}
                                                              dateFormat="DD/MM/yyyy"
                                                              input={true}
                                                              closeOnTab={true}
                                                              initialValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? new Date(
                                                                      dt[
                                                                        data_level1
                                                                      ][key][
                                                                        key2
                                                                      ].value
                                                                    )
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? new Date(
                                                                      dt[
                                                                        data_level1
                                                                      ][key][
                                                                        key2
                                                                      ].value
                                                                    )
                                                                  : ""
                                                              }
                                                              onChange={e => {
                                                                if (
                                                                  typeof e.isValid !==
                                                                    "undefined" &&
                                                                  e._isValid
                                                                ) {
                                                                  setDt({
                                                                    ...dt,
                                                                    [data_level1]: {
                                                                      ...dt[
                                                                        data_level1
                                                                      ],
                                                                      [key]: {
                                                                        ...dt[
                                                                          data_level1
                                                                        ][key],
                                                                        [key2]: {
                                                                          ...dt[
                                                                            data_level1
                                                                          ][
                                                                            key
                                                                          ][
                                                                            key2
                                                                          ],
                                                                          key:
                                                                            data2.key,
                                                                          value: e.format(
                                                                            "YYYY/MM/DD"
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  });
                                                                }
                                                              }}
                                                              readOnly={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type ===
                                                  "datetime" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="date"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <Datetime
                                                              inputProps={{
                                                                placeholder:
                                                                  data2.label,
                                                                disabled:
                                                                  formData.manualStatus &&
                                                                  formData
                                                                    .manualStatus[
                                                                    data_level1
                                                                  ] &&
                                                                  formData
                                                                    .manualStatus[
                                                                    data_level1
                                                                  ][key] ===
                                                                    true
                                                                    ? false
                                                                    : true
                                                                // required: true
                                                              }}
                                                              name={data2.key}
                                                              locale="id-ID"
                                                              timeFormat="HH:mm"
                                                              dateFormat="DD/MM/yyyy"
                                                              input={true}
                                                              closeOnTab={true}
                                                              initialValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? new Date(
                                                                      dt[
                                                                        data_level1
                                                                      ][key][
                                                                        key2
                                                                      ].value
                                                                    )
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? new Date(
                                                                      dt[
                                                                        data_level1
                                                                      ][key][
                                                                        key2
                                                                      ].value
                                                                    )
                                                                  : ""
                                                              }
                                                              onChange={e => {
                                                                if (
                                                                  typeof e.isValid !==
                                                                    "undefined" &&
                                                                  e._isValid
                                                                ) {
                                                                  let tgl = e.format(
                                                                    "YYYY-MM-DD HH:mm:ss"
                                                                  );

                                                                  setDt({
                                                                    ...dt,
                                                                    [data_level1]: {
                                                                      ...dt[
                                                                        data_level1
                                                                      ],
                                                                      [key]: {
                                                                        ...dt[
                                                                          data_level1
                                                                        ][key],
                                                                        [key2]: {
                                                                          ...dt[
                                                                            data_level1
                                                                          ][
                                                                            key
                                                                          ][
                                                                            key2
                                                                          ],
                                                                          key:
                                                                            data2.key,
                                                                          value: new Date(
                                                                            tgl
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  });
                                                                }
                                                              }}
                                                              readOnly={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type ===
                                                  "currency" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        <div data-testid="selectNIK">
                                                          {formData.status
                                                            .frmDetailPengajuan ? (
                                                            <input
                                                              name={data2.key}
                                                              className="form-control"
                                                              id={data2.key}
                                                              type="text"
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? rupiah(
                                                                      dt[
                                                                        data_level1
                                                                      ][key][
                                                                        key2
                                                                      ].value
                                                                    )
                                                                  : ""
                                                              }
                                                              style={{
                                                                backgroundColor:
                                                                  "#c9d1d8"
                                                              }}
                                                              disabled
                                                            />
                                                          ) : (
                                                            <NumberFormat
                                                              data-testid="nominal penghasilan"
                                                              id={data2.key}
                                                              name={data2.key}
                                                              placeholder={
                                                                "Masukkan " +
                                                                data2.label
                                                              }
                                                              thousandSeparator={
                                                                true
                                                              }
                                                              prefix={"Rp. "}
                                                              className="form-control"
                                                              defaultValue={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              value={
                                                                dt[
                                                                  data_level1
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2] &&
                                                                dt[data_level1][
                                                                  key
                                                                ][key2].value
                                                                  ? dt[
                                                                      data_level1
                                                                    ][key][key2]
                                                                      .value
                                                                  : ""
                                                              }
                                                              onChange={e =>
                                                                handleChangeInputText(
                                                                  e,
                                                                  data2.key,
                                                                  data_level1,
                                                                  "level2",
                                                                  key,
                                                                  key2
                                                                )
                                                              }
                                                              // required
                                                              readOnly={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? false
                                                                  : true
                                                              }
                                                              style={
                                                                formData.manualStatus &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ] &&
                                                                formData
                                                                  .manualStatus[
                                                                  data_level1
                                                                ][key] === true
                                                                  ? {
                                                                      backgroundColor:
                                                                        ""
                                                                    }
                                                                  : {
                                                                      backgroundColor:
                                                                        "#c9d1d8"
                                                                    }
                                                              }
                                                            />
                                                          )}
                                                        </div>
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : data2.type === "image" ||
                                                  data2.type === "file" ? (
                                                  <>
                                                    <FormGroup className="row">
                                                      <Col sm="12">
                                                        <Label
                                                          className="col-form-label"
                                                          htmlFor="nik"
                                                        >
                                                          <b>{data2.label}</b>
                                                        </Label>
                                                        {loads ? (
                                                          <div className="row">
                                                            <div
                                                              className="col-sm-12"
                                                              align="center"
                                                            >
                                                              <img
                                                                alt="loading"
                                                                src={require("../../../assets/images/tes-loading.gif")}
                                                                style={{
                                                                  borderRadius:
                                                                    "10px",
                                                                  width: "100px"
                                                                }}
                                                              />
                                                            </div>
                                                          </div>
                                                        ) : 
                                                          statusData === "detail"
                                                          ?
                                                            <div className="row">
                                                              <div className="col-12" align="center">
                                                                {
                                                                  data2.type === "image" ? (
                                                                    <img
                                                                      src={dt[data_level1] && dt[data_level1][key] && dt[data_level1][key][key2] ? dt[data_level1][key][key2].value : ''}
                                                                      style={{
                                                                        width: "470px",
                                                                        marginBottom: '20px'
                                                                      }}
                                                                      alt=""
                                                                    />
                                                                  ) : (
                                                                    <img
                                                                      src={require("../../../assets/images/file-icon.png")}
                                                                      style={{
                                                                        width:"270px",
                                                                      }}
                                                                      alt=""
                                                                    />
                                                                  )
                                                                }
                                                              </div>
                                                              <div className="col-12 mt-4" align="center">
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-success"
                                                                  onClick={() => {
                                                                    getFilePreview(dt[data_level1][key][key2].value)
                                                                  }}
                                                                >
                                                                  Download
                                                                </button>
                                                              </div>
                                                            </div>
                                                          :
                                                          (
                                                            <Dropzone
                                                              onDrop={acceptedFiles =>
                                                                processGbr(
                                                                  acceptedFiles,
                                                                  data2.key,
                                                                  data2.type,
                                                                  data_level1,
                                                                  "level2",
                                                                  key,
                                                                  key2
                                                                )
                                                              }
                                                              maxFiles={12}
                                                            >
                                                              {({
                                                                getRootProps,
                                                                getInputProps
                                                              }) => (
                                                                <section>
                                                                  <div
                                                                    {...getRootProps()}
                                                                    style={{
                                                                      minHeight:
                                                                        "100px",
                                                                      paddingTop:
                                                                        "40px",
                                                                      padding:
                                                                        "5px 5px 5px 5px",
                                                                      border:
                                                                        "1px solid #d2d2d2"
                                                                    }}
                                                                  >
                                                                    <input
                                                                      {...getInputProps()}
                                                                    />
                                                                    <div
                                                                      style={{
                                                                        justifyContent:
                                                                          "center",
                                                                        alignItems:
                                                                          "center"
                                                                      }}
                                                                    >
                                                                      <p className="text-center">
                                                                        {dt[
                                                                          data_level1
                                                                        ] &&
                                                                        dt[
                                                                          data_level1
                                                                        ][key] &&
                                                                        dt[
                                                                          data_level1
                                                                        ][key][
                                                                          key2
                                                                        ] &&
                                                                        dt[
                                                                          data_level1
                                                                        ][key][
                                                                          key2
                                                                        ]
                                                                          .value ? (
                                                                          data2.type ===
                                                                          "image" ? (
                                                                            <img
                                                                              src={
                                                                                dt[
                                                                                  data_level1
                                                                                ][
                                                                                  key
                                                                                ][
                                                                                  key2
                                                                                ]
                                                                                  .value
                                                                              }
                                                                              style={{
                                                                                width:
                                                                                  "470px"
                                                                              }}
                                                                              alt=""
                                                                            />
                                                                          ) : (
                                                                            <img
                                                                              src={require("../../../assets/images/file-icon.png")}
                                                                              style={{
                                                                                width:
                                                                                  "270px"
                                                                              }}
                                                                              alt=""
                                                                            />
                                                                          )
                                                                        ) : (
                                                                          <Label
                                                                            className="col-form-label text-center"
                                                                            htmlFor="inputEmail3"
                                                                          >
                                                                            Drag
                                                                            'n'
                                                                            drop
                                                                            some
                                                                            files
                                                                            here,
                                                                            or
                                                                            click
                                                                            to
                                                                            select
                                                                            files
                                                                          </Label>
                                                                        )}
                                                                      </p>
                                                                    </div>
                                                                  </div>
                                                                </section>
                                                              )}
                                                            </Dropzone>
                                                          )
                                                        }
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        );
                                      })}
                                    </>
                                  );
                                })}
                                <hr />
                              </div>
                              {formData.status.frmDetailPengajuan ? (
                                ""
                              ) : (
                                <div>
                                  <FormGroup className="row">
                                    <Col sm="12">
                                      {key > 0 ? (
                                        key ===
                                        fieldInputan[data_level1].length - 1 ? (
                                          <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => {
                                              hapusComponent(data_level1, key);
                                            }}
                                          >
                                            Hapus {sectionData}
                                          </button>
                                        ) : (
                                          ""
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </Col>
                                  </FormGroup>
                                </div>
                              )}
                            </>
                          );
                        }
                    })}
                  </>
                ) : (
                  <></>
                );
              })
            ) : (
              <></>
            )}
            {optionData.dataSurat &&
            optionData.dataSurat.jenis_layanan === "Internal" &&
            dt.dasar_surat &&
            dt.dasar_surat[0] &&
            dt.dasar_surat[0].value ? (
              <div className="form-row">
                <div className="col-12">
                  <div
                    style={{
                      backgroundColor: "grey",
                      paddingTop: "15px",
                      paddingBottom: "15px",
                      paddingLeft: "15px",
                      color: "white",
                      marginBottom: "15px",
                      textTransform: "capitalize"
                    }}
                  >
                    <b>Data Penandatangan</b>
                  </div>
                </div>
                {dt.dasar_surat &&
                dt.dasar_surat[0] &&
                dt.dasar_surat[0].value &&
                dt.dasar_surat[0].value.value == "Kecamatan" ? (
                  <>
                    <Col md="4 mb-3">
                      <Label>Nama</Label>
                      {formData.status.frmDetailPengajuan ? (
                        <input
                          data-testid="nama"
                          name="nama"
                          className="form-control"
                          id="nama"
                          type="text"
                          required
                          placeholder="Nama Penandatangan"
                          defaultValue={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][2].value
                              ? dt["data_penandatangan"][2].value
                              : ""
                          }
                          value={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][2].value
                              ? dt["data_penandatangan"][2].value
                              : ""
                          }
                          style={{ backgroundColor: "#c9d1d8" }}
                          disabled
                        />
                      ) : (
                        <input
                          data-testid="nama"
                          name="nama"
                          className="form-control"
                          id="nama"
                          type="text"
                          required
                          placeholder="Nama Penandatangan"
                          defaultValue={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][2].value
                              ? dt["data_penandatangan"][2].value
                              : ""
                          }
                          value={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][2].value
                              ? dt["data_penandatangan"][2].value
                              : ""
                          }
                          onChange={e =>
                            handleChangeInputText(
                              e,
                              "nama",
                              "data_penandatangan",
                              "level1",
                              2,
                              ""
                            )
                          }
                        />
                      )}
                    </Col>
                    <Col md="4 mb-3">
                      <Label>NIP</Label>
                      {formData.status.frmDetailPengajuan ? (
                        <input
                          data-testid="nip"
                          name="nip"
                          className="form-control"
                          id="nip"
                          type="text"
                          required
                          placeholder="NIP Penandatangan"
                          defaultValue={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][3].value
                              ? dt["data_penandatangan"][3].value
                              : ""
                          }
                          value={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][3].value
                              ? dt["data_penandatangan"][3].value
                              : ""
                          }
                          style={{ backgroundColor: "#c9d1d8" }}
                          disabled
                        />
                      ) : (
                        <input
                          data-testid="nip"
                          name="nip"
                          className="form-control"
                          id="nip"
                          type="text"
                          required
                          placeholder="NIP Penandatangan"
                          defaultValue={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][3].value
                              ? dt["data_penandatangan"][3].value
                              : ""
                          }
                          value={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][3].value
                              ? dt["data_penandatangan"][3].value
                              : ""
                          }
                          onChange={e =>
                            handleChangeInputText(
                              e,
                              "nip",
                              "data_penandatangan",
                              "level1",
                              3,
                              ""
                            )
                          }
                        />
                      )}
                    </Col>
                    <Col md="4 mb-3">
                      <Label>Golongan</Label>
                      {formData.status.frmDetailPengajuan ? (
                        <input
                          data-testid="golongan"
                          name="golongan"
                          className="form-control"
                          id="golongan"
                          type="text"
                          required
                          placeholder="Golongan Penandatangan"
                          defaultValue={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][4].value
                              ? dt["data_penandatangan"][4].value
                              : ""
                          }
                          value={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][4].value
                              ? dt["data_penandatangan"][4].value
                              : ""
                          }
                          style={{ backgroundColor: "#c9d1d8" }}
                          disabled
                        />
                      ) : (
                        <input
                          data-testid="golongan"
                          name="golongan"
                          className="form-control"
                          id="golongan"
                          type="text"
                          required
                          placeholder="Golongan Penandatangan"
                          defaultValue={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][4].value
                              ? dt["data_penandatangan"][4].value
                              : ""
                          }
                          value={
                            dt["data_penandatangan"] &&
                            dt["data_penandatangan"][4].value
                              ? dt["data_penandatangan"][4].value
                              : ""
                          }
                          onChange={e =>
                            handleChangeInputText(
                              e,
                              "golongan",
                              "data_penandatangan",
                              "level1",
                              4,
                              ""
                            )
                          }
                        />
                      )}
                    </Col>
                  </>
                ) : (
                  <>
                    <Col md="12 mb-3">
                      <table className="table table-bordered table-stripes table-hovered">
                        <thead>
                          <tr>
                            {formData.status.frmDetailPengajuan ? (
                              ""
                            ) : (
                              <th>No</th>
                            )}
                            <th>Jabatan</th>
                            <th>Jabatan Pengganti</th>
                            <th>Nama</th>
                            <th>NIP</th>
                            <th>Status</th>
                            {formData.status.frmDetailPengajuan ? (
                              ""
                            ) : (
                              <th>Aksi</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {formData.listPerangkatDesa.map((data, i) => {
                            return formData.status.frmDetailPengajuan ? (
                              formData.accButtonPerangkatDesa[i] === "1" ? (
                                <tr key={i}>
                                  <td>{data.jabatan}</td>
                                  <td>
                                    {data.jabatan_pengganti
                                      ? data.jabatan_pengganti
                                      : "-"}
                                  </td>
                                  <td>{data.nama}</td>
                                  <td>{data.nip ? data.nip : "-"}</td>
                                  <td>{data.status ? data.status : "-"}</td>
                                </tr>
                              ) : (
                                ""
                              )
                            ) : (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{data.jabatan}</td>
                                <td>
                                  {data.jabatan_pengganti
                                    ? data.jabatan_pengganti
                                    : "-"}
                                </td>
                                <td>{data.nama}</td>
                                <td>{data.nip ? data.nip : "-"}</td>
                                <td>{data.status ? data.status : "-"}</td>
                                <td>
                                  <Button
                                    data-testid={"btnPilihPerangkat-" + i}
                                    size="xs"
                                    onClick={() => {
                                      let temp = formData.accButtonPerangkatDesa.map(
                                        x => "0"
                                      );
                                      temp[i] = "1";

                                      setFormData({
                                        ...formData,
                                        accButtonPerangkatDesa: temp,
                                        ttdSelected: data
                                      });
                                    }}
                                    color={
                                      formData.accButtonPerangkatDesa[i] === "0"
                                        ? "danger"
                                        : "default"
                                    }
                                    className="btn-icon"
                                  >
                                    {formData.accButtonPerangkatDesa[i] === "1"
                                      ? "Dipilih"
                                      : "Pilih"}
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </Col>
                  </>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => {
                // Tutup modal
                setFormData({
                  ...formData,
                  status: {
                    ...formData.status,
                    form: false,
                    frmPreviewDraft: false,
                    frmDetailPengajuan: false,
                    jenis_form: ""
                  }
                });
                setIsOpen(false);
              }}
            >
              Tutup
            </button>
            {formData.status.frmDetailPengajuan ? (
              ""
            ) : (
              <button
                data-testid="btnSubmitCreate"
                type="submit"
                className="btn btn-primary-custom"
                disabled={formData.status.btnForm}
              >
                Simpan
              </button>
            )}
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalSuratGaib;
